"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMarkActivityAsSpoken;

var _react = require("react");

var _useMarkActivity = _interopRequireDefault(require("./internal/useMarkActivity"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useMarkActivityAsSpoken() {
  var markActivity = (0, _useMarkActivity.default)();
  return (0, _react.useCallback)(function (activity) {
    return markActivity(activity, 'speak', false);
  }, [markActivity]);
}